import styled from 'styled-components';

export const ModalBox = styled.div`
    .modal-content {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1076px;
        max-width: 95%;
        height: auto;
        z-index: 4;
        padding: 16px;

        .close, .close:hover {
            position: absolute;
            right: -15px;
            top: -15px;
            width: 30px;
            height: 30px;
            background-color: #fff;
            text-shadow: none;
            opacity: unset;
            -webkit-border-radius: 30px;
            -moz-border-radius: 30px;
            border-radius: 30px;
            -moz-box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.6);
            box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.6);

            span {
                font-family: Poppins, Heltica, Arial, sans-serif;
                color: #A2A2A2;
                font-size: 1em;
            }
        }

        .modal-header, .modal-footer {
            border: none;
        }

        .modal-body {
            padding: 34px 110px;

            h5 {
                margin-bottom: 40px;
            }

            h5, p {
                display: block;
                width: 100%;
                font-family: Poppins, Heltica, Arial, sans-serif;
                font-size: 2.6em;
                text-align: center;
                color: #505059;
            }
        }

        .modal-footer {
            padding: 0;

            button {
                font-family: Poppins-Medium, Heltica, Arial, sans-serif;
            }
        }
    }

    .modal-overlay {
        z-index: 3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }
`;
